function routerConfig($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider
    .when('/course/:slug', '/course/:slug/overview');
  $stateProvider
    .state('app.ecourse', {
      abstract: true,
      url: 'course/:slug?purchaseType',
      sticky: true,
      resolve: {
        ecourse: function (Ecourses, $stateParams) {
          'ngInject';
          return Ecourses.get($stateParams.slug);
        }
      },
      'views': {
        'app.layout': {
          templateUrl: 'app/ecourse/shared/layout.html',
          controller: 'EcourseController',
          controllerAs: 'ecourseCtrl'
        }
      }
    })
    .state('app.ecourse.overview', {
      url: '/overview',
      views: {
        'app.ecourse.content': {
          templateUrl: 'app/ecourse/overview/overview.html',
          controller: 'OverviewController',
          controllerAs: 'ctrl'
        }
      }
    }
  )
    .state('app.ecourse.segment', {
      url: '/:segment',
      params: {
        media: null,
        play: false
      },
      views: {
        'app.ecourse.content': {
          templateUrl: 'app/ecourse/segment/segment.html',
          controller: 'SegmentController',
          controllerAs: 'ctrl'
        }
      }
    }
  );
}
export default routerConfig;




/** WEBPACK FOOTER **
 ** ./src/app/ecourse/ecourse.route.js
 **/